import { notification } from 'antd'
import {
  RuleType,
  brandParam,
  maxRuleLength,
  sectorParam,
  supergroupParam,
  supergroupSuperParam,
  visibilityParam,
} from '../Constants/Configuration'
import { TranslationKeys } from '../Constants/TranslationKeys'
import { Rule, addRule } from '../Slices/Omnichannel/SeasonRuleSlice'
import { renderTranslation } from './GenericHelpers'
import dayjs from 'dayjs'
import { addDays, convertDateToRomeTimeZone, getDayDiff } from './DateHelpers'
import { NavigationWrapper } from './NavigateHelper'
import { RuleLock } from '../Slices/Omnichannel/LockSlice'
import { TypeOfChannel } from 'Slices/Omnichannel/DiscountSlice'
import { Store } from 'antd/lib/form/interface'
import { getStatsData } from 'Services/Omnichannel/DiscountService'

const key = (...args: (string | number)[]): string => args.join(',')

function obtainExcelDataFromDiscountData(discountData) {
  return async function (dispatch, getState) {
    let exceldata = [] as any
    let statdata = [] as any

    discountData.superGroupDiscounts.forEach(superGroupDiscount => {
      superGroupDiscount.sectorDiscounts.forEach(sectorDiscount => {
        sectorDiscount.channelDiscounts.forEach(channelDiscount => {
          const channelName = channelDiscount.channel
          const superGroupName = superGroupDiscount.superGroup.name
          const sectorName = sectorDiscount.sector.name
          const superGroupId = superGroupDiscount.superGroup.id
          const sectorId = sectorDiscount.sector.id
          channelDiscount.brandDiscounts.forEach(brandDiscount => {
            const brandName = brandDiscount.brand.name
            const brandId = brandDiscount.brand.id
            const discount = brandDiscount.noArticles
              ? null
              : brandDiscount.discount !== null
              ? brandDiscount.discount
              : channelDiscount.discount !== null
              ? channelDiscount.discount
              : sectorDiscount.discount !== null
              ? sectorDiscount.discount
              : discountData.generalDiscount

            const existingIndex = exceldata.findIndex(
              item =>
                item.f1_brand === brandName && item.f2_supergroup === superGroupName && item.f3_sector === sectorName,
            )

            if (existingIndex !== -1) {
              exceldata[existingIndex]['x_' + channelName] = discount
            } else {
              statdata = [
                ...statdata,
                {
                  Brand: { id: brandId, name: brandName },
                  Supergroup: { id: superGroupId, name: superGroupName },
                  Sector: { id: sectorId, name: sectorName },
                },
              ]
              exceldata = [
                ...exceldata,
                {
                  f1_brand: brandName,
                  f2_supergroup: superGroupName,
                  f3_sector: sectorName,
                  f4_sellout: 0,
                  f5_markup: 0,
                  ['x_' + channelName]: discount,
                },
              ]
            }
          })
        })
      })
    })

    const statDetails = await dispatch(getStatsData(statdata))

    return { RowWorkDetails: exceldata, statDetails: statDetails }
  }
}

const obtainExcelDataFromsubRuleArticles = subRuleArticles => {
  let exceldata = []
  console.log(subRuleArticles)
  subRuleArticles.results.forEach(art => {
    exceldata = [
      ...exceldata,
      {
        articleid: art.key,
        articleCode: art.articleCode,
        brand: art.brand,
        supergruppo: art.category,
        settore: art.department,
        ordinato$qta: art.ordQta,
        ordinato$val: art.ordVal,
        consegnato$qta: art.acqQta,
        consegnato$val: art.acqVal,
        consegnatop: art.deliveredPerc,
        venduto$qta: art.venQta,
        venduto$val: art.venVal,
        gg: art.stockDays,
        sellout: art.sellout,
        esistenza$qta: art.existing,
        esistenza$val: art.esiVal,
        disponiblità$qta: art.disQta,
        disponiblità$val: art.disVal,
        prezzoven: art.retailPrice,
        prezzoacq: art.originalRetailPrice,
      },
    ]
    art.channels.forEach(li => {
      exceldata[exceldata.length - 1][li.channel + '_venqtà'] = li.venQta
      exceldata[exceldata.length - 1][li.channel + '_venval'] = li.venVal
      exceldata[exceldata.length - 1][li.channel + '_sc'] = li.discount
      exceldata[exceldata.length - 1][li.channel + '_markperc'] = li.markupPerc
      exceldata[exceldata.length - 1][li.channel + '_markavg'] = li.markupMedio
    })
  })

  return exceldata
}

const obtainDiscountDataParts = discountData => {
  const superGroupsMap = new Map<string, any>()
  const brandsMap = new Map<string, any>()
  const sectorDiscountsMap = new Map<string, any>()
  const pricelistDiscountsMap = new Map<string, any>()
  const brandDiscountsMap = new Map<string, any>()

  if (Object.keys(discountData).length > 0) {
    discountData.superGroupDiscounts.forEach(({ superGroup, sectorDiscounts }) => {
      sectorDiscounts.forEach(({ sector, discount, channelDiscounts }) => {
        if (!sectorDiscountsMap.has(key(sector.id, superGroup.id))) {
          const sectorToAdd = { ...sector }
          sectorToAdd['supergroup'] = superGroup.id
          sectorToAdd['discount'] = discount
          sectorDiscountsMap.set(key(sector.id, superGroup.id), sectorToAdd)
        }

        channelDiscounts.forEach(({ channel, discount, brandDiscounts }) => {
          if (!pricelistDiscountsMap.has(key(superGroup.id, sector.id, channel))) {
            const channelToAdd = { channel }
            channelToAdd['supergroup'] = superGroup.id
            channelToAdd['sector'] = sector.id
            channelToAdd['discount'] = discount
            pricelistDiscountsMap.set(key(superGroup.id, sector.id, channel), channelToAdd)
          }

          brandDiscounts.forEach(({ brand, discount, noArticles }) => {
            if (!brandsMap.has(key(brand.id))) {
              brandsMap.set(key(brand.id), brand)
            }

            if (!brandDiscountsMap.has(key(superGroup.id, sector.id, channel, brand.id))) {
              const brandToAdd = { ...brand }
              brandToAdd['supergroup'] = superGroup.id
              brandToAdd['sector'] = sector.id
              brandToAdd['channel'] = channel
              brandToAdd['discount'] = discount
              brandToAdd['noArticles'] = noArticles

              brandDiscountsMap.set(key(superGroup.id, sector.id, channel, brand.id), brandToAdd)
            }
          })
        })
      })

      if (sectorDiscounts.some(x => x.channelDiscounts?.length > 0)) superGroupsMap.set(key(superGroup.id), superGroup)
    })
  }
  return [superGroupsMap, brandsMap, sectorDiscountsMap, pricelistDiscountsMap, brandDiscountsMap]
}

const obtainPriceListFromData = (discountData, supergroup, sector, priceList) => {
  let filteredPriceList = {} as any
  if (Object.keys(discountData).length > 0) {
    discountData.superGroupDiscounts.forEach(currSupergroup => {
      if (currSupergroup.superGroup.id === supergroup) {
        currSupergroup.sectorDiscounts.forEach(currSector => {
          if (currSector.sector.id === sector) {
            currSector.channelDiscounts.forEach(currPriceList => {
              if (currPriceList.channel === priceList) {
                const brandDiscounts = currPriceList.brandDiscounts.filter(x => !x.noArticles)
                const correctPriceList = {
                  sector: { id: currSector.sector.id, discount: currSector.discount },
                  channel: { name: currPriceList.channel, discount: currPriceList.discount },
                  brandDiscounts: brandDiscounts ? brandDiscounts : [],
                  generalDiscount: discountData?.generalDiscount ?? 0,
                }
                filteredPriceList = correctPriceList
              }
            })
          }
        })
      }
    })
  }

  return filteredPriceList
}

const obtainPriceDiscount = (
  discountFilteredWithoutPriceListCopyTo,
  supergroupfrom,
  sectorfrom,
  priceListfrom,
  dataActivePriceList,
) => {
  //cerco in maniera gerarchica listino (chan) -> settore -> sconto generale
  //channel
  const activeChannelDiscount = discountFilteredWithoutPriceListCopyTo.find(
    x => x.superGroup === supergroupfrom && x.sector === sectorfrom && x.channel === priceListfrom && !x.brand,
  )

  if (activeChannelDiscount?.discount) return activeChannelDiscount.discount

  if (dataActivePriceList?.channel?.discount) return dataActivePriceList.channel.discount

  //sector
  const activeSectorListDiscount = discountFilteredWithoutPriceListCopyTo.find(
    x => x.superGroup === supergroupfrom && x.sector === sectorfrom && !x.channel && !x.brand,
  )

  if (activeSectorListDiscount?.discount) return activeSectorListDiscount.discount

  if (dataActivePriceList?.sector?.discount) return dataActivePriceList.sector.discount

  //general
  const generalDiscountChanged = discountFilteredWithoutPriceListCopyTo.find(
    x => x.superGroup === supergroupfrom && !x.sector && !x.channel && !x.brand,
  )

  if (generalDiscountChanged?.discount) return generalDiscountChanged.discount

  return dataActivePriceList.generalDiscount
}

const obtainBrandsFromData = (discountData, supergroup, sector, priceList) => {
  let filteredBrandDiscounts = []
  if (Object.keys(discountData).length > 0) {
    discountData.superGroupDiscounts.forEach(currSupergroup => {
      if (currSupergroup.superGroup.id === supergroup) {
        currSupergroup.sectorDiscounts.forEach(currSector => {
          if (currSector.sector.id === sector) {
            currSector.channelDiscounts.forEach(currPriceList => {
              if (currPriceList.channel === priceList) {
                filteredBrandDiscounts = [...currPriceList.brandDiscounts]
              }
            })
          }
        })
      }
    })
  }

  return filteredBrandDiscounts.filter(x => !x.noArticles)
}

type DiscountElementId = { superGroup: number; sector: number; channel: string; brand: number }
const obtainDiscountElementsFromData = discountData => {
  const idItems: DiscountElementId[] = []
  if (Object.keys(discountData).length > 0) {
    discountData.superGroupDiscounts.forEach(currSupergroup => {
      currSupergroup.sectorDiscounts.forEach(currSector => {
        if (currSector.discount) {
          idItems.push({
            superGroup: currSupergroup.superGroup.id,
            sector: currSector.sector.id,
            channel: null,
            brand: null,
          })
        }
        currSector.channelDiscounts.forEach(currChannel => {
          if (currChannel.discount) {
            idItems.push({
              superGroup: currSupergroup.superGroup.id,
              sector: currSector.sector.id,
              channel: currChannel.channel,
              brand: null,
            })
          }
          currChannel.brandDiscounts.forEach(currBrand => {
            if (currBrand.discount) {
              idItems.push({
                superGroup: currSupergroup.superGroup.id,
                sector: currSector.sector.id,
                channel: currChannel.channel,
                brand: currBrand.brand.id,
              })
            }
          })
        })
      })
    })
  }
  return idItems
}

const isRuleNameMaxLengthValid = ruleName => {
  return ruleName && ruleName.length <= maxRuleLength
}

const isRuleNameMinLengthValid = ruleName => {
  return ruleName && ruleName.length > 0
}

const isRuleEditToDisable = (currentRule, isRuleActive) => {
  return currentRule && (!isRuleActive || isStartDateInvalidForRuleEdit(currentRule.startDate))
}

const isRuleLockedByOtherUsers = (locks: RuleLock[], ruleId, typeOfLock: string, user: String) => {
  return locks.findIndex(lock => lock.ruleId === ruleId && lock.typeOfLock == typeOfLock && lock.userId !== user) !== -1
}

const isRuleLockedByCurrentUser = (locks: RuleLock[], ruleId: Number, typeOfLock: string, user: String) => {
  return (
    locks.findIndex(lock => lock.ruleId === ruleId && lock.typeOfLock === typeOfLock && lock.userId === user) !== -1
  )
}

const isRuleNameUnique = (rules, ruleName: string, ruleId, editDisable) => {
  const rulesWithoutCurrent = rules.filter(x => x.id !== ruleId && x.virtualId !== ruleId)
  return !editDisable && ruleId && !rulesWithoutCurrent.find(x => x.name.trim() === ruleName.trim())
}

const retrieveCurrentSeasonAndRules = (ruleId, seasonRuleList) => {
  if (ruleId === undefined) return undefined
  return seasonRuleList.find(currRule => {
    return currRule.rules.find(x => x.id === ruleId || x.virtualId === ruleId) ? currRule : false
  })
}

const retrieveRule = (ruleId, seasonRuleList) => {
  if (ruleId && seasonRuleList && seasonRuleList.length !== 0) {
    const seasonMatch = retrieveCurrentSeasonAndRules(ruleId, seasonRuleList)
    if (seasonMatch) {
      return seasonMatch.rules.find(x => {
        return ruleId === (x.virtualId ? x.virtualId : x.id)
      })
    }
  }
  return null
}

const retrieveSubrule = (subRuleId, seasonRuleList) => {
  let subRuleMatch = {}
  seasonRuleList.forEach(season => {
    const rules = season.rules ?? []
    rules.forEach(rule => {
      if (Object.keys(subRuleMatch).length > 0) {
        return
      }

      const subRules = rule.subrules ?? []

      const currentSubrule = subRules.find(
        subRule => subRuleId === (subRule.virtualId ? subRule.virtualId : subRule.id),
      )

      if (currentSubrule) {
        subRuleMatch = currentSubrule
      }
    })
  })

  return Object.keys(subRuleMatch).length > 0 ? subRuleMatch : null
}

const retrieveRuleFromSubrule = (subRuleId, seasonRuleList) => {
  let ruleMatch = {}
  seasonRuleList.forEach(season => {
    const rules = season.rules ?? []
    rules.forEach(rule => {
      if (Object.keys(ruleMatch).length > 0) {
        return
      }
      const subRules = rule.subrules ?? []

      const currentSubruleIsInRuleSubruleList = subRules.find(
        subRule => subRuleId && subRuleId === (subRule.virtualId ? subRule.virtualId : subRule.id),
      )

      if (currentSubruleIsInRuleSubruleList) {
        ruleMatch = rule
      }
    })
  })

  return ruleMatch
}

const retrieveSeasonRuleSubrulesList = (subRuleId, seasonRuleList) => {
  let subrules = []
  seasonRuleList.forEach(season => {
    const rules = season.rules ?? []
    rules.forEach(rule => {
      if (subrules.length > 0) {
        return
      }
      const subRules = rule.subrules ?? []

      const currentSubruleIsInRuleSubruleList = subRules.find(
        subRule => subRuleId && subRuleId === (subRule.virtualId ? subRule.virtualId : subRule.id),
      )

      if (currentSubruleIsInRuleSubruleList) {
        subrules = subRules
      }
    })
  })

  return subrules
}

const retrieveSubruleId = (rule: Rule): number | undefined => {
  const subrules = rule.subrules ?? []
  const subrule = subrules[0]
  return subrule?.id
}

const retrieveAvailableSeasons = (seasonList, seasonRuleList) => {
  return seasonList.filter(season => {
    const isSeasonActiveWithRules = seasonRuleList.find(rule => {
      return season.id && rule.season.id ? season.id === rule.season.id : false
    })

    return !isSeasonActiveWithRules
  })
}

const retrieveChannelMatchWithPricelist = (currentChannel: string, channelList) => {
  return channelList.filter(x => x.pricelist && x.pricelist === currentChannel)
}

const retrieveSitesMatchWithPricelist = (pricelist: string, sitePricelists) => {
  const sitesAvailable = Object.keys(sitePricelists)
    .filter(value => {
      return sitePricelists[value].indexOf(pricelist) !== -1
    })
    .map(siteNumber => {
      return `Sito${siteNumber}`
    })
  return sitesAvailable
}

const retrieveStoresMatchWithPricelist = (pricelist: string, stores: Store[]) => {
  const sitesAvailable = stores
    .filter((store: Store) => {
      return store.pricelist === pricelist
    })
    .map((store: Store) => {
      return store.name
    })
  return sitesAvailable
}

const isStartDateInvalidForRuleEdit = startDate => {
  if (!startDate) return true

  const appDate = dayjs(startDate).subtract(1, 'minute')
  return dayjs().isAfter(appDate)
}

const generateRuleName = (ruleName, rules) => {
  let newRuleName = ruleName
  //rules is valid for an array of rule or subrules (same structure)
  const ruleNameMatch = rules.find(x => {
    return x.name.startsWith(ruleName)
  })

  const ruleEndHypherNumber = rules.filter(rule => {
    //put all the copies of a certain rule in this array
    const regex = new RegExp(`^${ruleName} - \\d+$`)
    return regex.test(rule.name)
  })

  if (ruleNameMatch) {
    if (ruleEndHypherNumber.length > 0) {
      const maxRuleNum = ruleEndHypherNumber.reduce((max, x) => {
        //check the max index of that copy
        const match = x.name.match(/\d+$/)
        const currentRuleNum = match ? parseInt(match[0], 10) : null
        return currentRuleNum !== null ? Math.max(max, currentRuleNum) : max
      }, null)
      newRuleName += ` - ${maxRuleNum + 1}` //add 1 that index to create an unused name
    } else {
      newRuleName += ' - ' + 2 //if there's no copy of that rule add '-2'
    }
  }
  return newRuleName
}

const generateVirtualSeason = seasonToAdd => {
  return {
    season: seasonToAdd,
    rules: [],
    isVirtual: true,
  }
}

export interface DiscountRule {
  season: any //@todo
  id: number
  virtualId: number
  name: string
  startDate: string
  endDate: string
  ruleType: RuleType
  filters: any //@todo
  isActive: boolean
  subrules: DiscountRule[]
  typeOfChannel: TypeOfChannel
  ruleDecimalPrice: string
}

const generateVirtualRuleData = (
  seasonRules,
  language,
  currentSeason,
  virtualRules,
  typeOfChannel: TypeOfChannel,
  ruleDecimalPrice: string,
): DiscountRule => {
  const [ruleDateCopy, ruleEndDateCopy] = calculateMostRecentSeasonRuleStartEndDate(seasonRules)

  const newRuleName = generateRuleName(
    renderTranslation(language, TranslationKeys.newRuleNameStart) +
      ' ' +
      (currentSeason?.isCarryOver
        ? renderTranslation(language, TranslationKeys.seasonBoxCarryOver)
        : currentSeason?.isOutlet
        ? renderTranslation(language, TranslationKeys.seasonBoxOutlet)
        : currentSeason.alwaysOnSale
        ? renderTranslation(language, 'Sempre in saldo')
        : currentSeason?.name
        ? currentSeason?.name
        : ''),
    seasonRules,
  )
  const isStoreRule = currentSeason?.alwaysOnSale
  const type =
    typeOfChannel != TypeOfChannel.Store || (typeOfChannel == TypeOfChannel.Store && isStoreRule)
      ? RuleType.season
      : RuleType.salesPeriod

  return {
    season: currentSeason,
    id: 0,
    virtualId: (virtualRules.length + 1) * -1,
    name: newRuleName,
    startDate: ruleDateCopy.toISOString(),
    endDate: ruleEndDateCopy.toISOString(),
    ruleType: type,
    filters: null,
    isActive: true,
    subrules: [],
    typeOfChannel: typeOfChannel,
    ruleDecimalPrice: ruleDecimalPrice,
  }
}

const retrieveVirtualRulesFromSeasonRuleList = seasonRuleList => {
  if (seasonRuleList && seasonRuleList.length !== 0) {
    const ruleMapped = seasonRuleList.reduce((prev, curr) => {
      return prev.concat(curr?.rules ?? [])
    }, [])

    return retrieveVirtualRules(ruleMapped)
  }
  return []
}

const retrieveVirtualSubRulesFromSeasonRuleList = seasonRuleList => {
  if (seasonRuleList && seasonRuleList.length !== 0) {
    const ruleMapped = seasonRuleList.reduce((prev, curr) => {
      return prev.concat(curr?.rules ?? [])
    }, [])

    const subRuleMapped = ruleMapped.reduce((prev, curr) => {
      return prev.concat(curr?.subrules ?? [])
    }, [])

    return retrieveVirtualRules(subRuleMapped)
  }
  return []
}

const createNewVirtualRule =
  (seasonRules, seasonRuleList, language, currentSeason, navigationWrapper: NavigationWrapper) =>
  (dispatch, getState) => {
    const state = getState()
    const virtualRules = retrieveVirtualRulesFromSeasonRuleList(seasonRuleList)
    const virtualRule = generateVirtualRuleData(
      seasonRules,
      language,
      currentSeason,
      virtualRules,
      state.present.discount.typeOfChannel,
      '0',
    )
    if (virtualRule.name.length > maxRuleLength) {
      return notification.open({
        description: renderTranslation(language, TranslationKeys.warningSeasonTextCharLength),
        placement: 'topLeft',
        message: '',
      })
    }

    // add new season rule to existing season
    dispatch(addRule(virtualRule))

    if (seasonRules.length === 0) {
      navigationWrapper?.navigateToRule(virtualRule.virtualId)
    }
  }

const createNewVirtualSubrule = (language, currentRule: DiscountRule, virtualSubRules, superGroup, sector, brand) => {
  const subRules = currentRule.subrules || []
  const newRuleName = generateRuleName(
    renderTranslation(language, TranslationKeys.newSubruleNameStart) +
      (brand ? ' ' + brand : sector ? ' ' + sector : superGroup ? ' ' + superGroup : '') +
      (currentRule ? ' ' + currentRule.name : ''),
    subRules,
  )

  if (newRuleName.length > maxRuleLength) {
    notification.open({
      description: renderTranslation(language, TranslationKeys.warningSeasonTextCharLength),
      placement: 'topLeft',
      message: '',
    })
    return {} as any
  }

  const virtualSubrule: DiscountRule = {
    season: currentRule && currentRule.season ? currentRule.season : {},
    id: 0,
    virtualId: (virtualSubRules.length + 1) * -1,
    name: newRuleName,
    startDate: dayjs().startOf('day').toDate().toISOString(),
    endDate: dayjs().startOf('day').toDate().toISOString(),
    ruleType: RuleType.season,
    filters: null,
    isActive: false,
    subrules: null,
    typeOfChannel: currentRule.typeOfChannel,
    ruleDecimalPrice: '0',
  }

  return {
    season:
      currentRule.season && currentRule.season.name
        ? currentRule.season.name
        : currentRule.season.outlet
        ? renderTranslation(language, TranslationKeys.seasonBoxOutlet)
        : currentRule.season.carryOver
        ? renderTranslation(language, TranslationKeys.seasonBoxCarryOver)
        : '', //filter values,
    superGroupValue: superGroup,
    sectorValue: sector,
    brandValue: brand,
    virtualSubrule: virtualSubrule,
  }
}

const generateRuleCopy = (
  language,
  ruleName,
  currentSeasonRules,
  ruleType,
  currentRule: DiscountRule,
): DiscountRule => {
  const copyOf = renderTranslation(language, TranslationKeys.newRuleNameCopy)
  const isCopyOfIncluded = ruleName.includes(copyOf)
  const newName = isCopyOfIncluded ? ruleName : copyOf + ' ' + ruleName

  const newRuleName = generateRuleName(newName, currentSeasonRules)

  const [ruleDateCopy, ruleEndDateCopy] = calculateMostRecentSeasonRuleStartEndDate(currentSeasonRules)

  return {
    season: currentRule.season,
    id: 0,
    name: newRuleName,
    startDate: ruleDateCopy.toISOString(),
    endDate: ruleEndDateCopy.toISOString(),
    ruleType: ruleType,
    filters: null,
    isActive: true,
    subrules: null,
    virtualId: null,
    typeOfChannel: currentRule.typeOfChannel,
    ruleDecimalPrice: currentRule.ruleDecimalPrice,
  }
}

const retrieveVirtualRules = ruleList => {
  return ruleList.filter(x => {
    return !!x.virtualId
  })
}

const calculateMostRecentSeasonRuleStartEndDate = rulesArray => {
  if (rulesArray && rulesArray.length > 0) {
    const today = new Date()
    const lastRuleStartDate = new Date(
      Math.max.apply(
        null,
        rulesArray.map(x => {
          return new Date(x.startDate)
        }),
      ),
    )
    const lastRuleEndDate = new Date(
      Math.max.apply(
        null,
        rulesArray.map(x => {
          return new Date(x.endDate)
        }),
      ),
    )

    //prevent endDate that is set to today to set huge date difference
    //This case concerns season rule with only start date, sale and promo don't trigger this behavior
    const endDate = lastRuleEndDate.getTime() < lastRuleStartDate.getTime() ? lastRuleStartDate : lastRuleEndDate
    const daysDiff = getDayDiff(lastRuleStartDate, endDate)
    const days = daysDiff === 0 ? 1 : daysDiff
    const lastStartDate =
      lastRuleStartDate.getTime() < today.getTime()
        ? addDays(today, 7)
        : addDays(new Date(lastRuleStartDate.getTime()), days)

    lastStartDate.setDate(lastStartDate.getDate())

    //set end date always to 1 day after start date, to prevent huge date days added from several copy
    const lastEndDate = addDays(lastStartDate, 1)
    lastStartDate.setHours(0, 0, 0)
    lastEndDate.setHours(23, 59, 59)
    return [lastStartDate, lastEndDate]
  }

  const startDate = new Date()
  startDate.setDate(startDate.getDate() + 1)
  startDate.setHours(0, 0, 0)
  const endDate = new Date()
  endDate.setDate(endDate.getDate() + 1)
  endDate.setHours(23, 59, 59)
  return [startDate, endDate]
}

const retrievePricelistForSubrule = subRuleData => {
  const subRuleInfo = subRuleData.find(x => x?.channels && x?.channels.length > 0)
  const priceLists = subRuleInfo?.channels ?? []
  return priceLists
}

const selectedRuleIsInSeason = (seasonRules, ruleId, subruleId) => {
  //props.seasonObj?.rules?
  return seasonRules?.find(
    rule =>
      rule.id === ruleId ||
      rule.virtualId === ruleId ||
      (rule.subRules && rule.subRules.find(subrule => subrule.id === subruleId || subrule.virtualId === subruleId)),
  )
}

const deleteVirtualSubrules = seasonRuleList => {
  seasonRuleList.forEach(seasonRules => {
    seasonRules.rules.forEach(rule => {
      const subrules = rule?.subrules || []
      rule.subrules = subrules.filter(x => !x.virtualId)
    })
  })
}

const ruleHasSubrules = (rule: any): boolean => {
  const subrules = rule.subrules ?? []
  return subrules.length === 0
}

const generateSubruleParams = (
  useSuperGroupSuper: boolean,
  supergroup?: string,
  sector?: string,
  brand?: string,
  articleFilter?: string,
): { [key: string]: string } => {
  let params = {}

  if (supergroup) {
    if (useSuperGroupSuper) {
      params[supergroupSuperParam] = supergroup
    } else {
      params[supergroupParam] = supergroup
    }
  }

  if (sector) {
    params[sectorParam] = sector
  }

  if (brand) {
    params[brandParam] = brand
  }

  if (articleFilter) {
    params[visibilityParam] = articleFilter
  }

  return params
}

const retrieveActiveListings = (typeOfChannel: TypeOfChannel, allPricelists) => {
  return allPricelists
    .filter(pricelist => pricelist.typeOfChannel === typeOfChannel)
    .map(pricelist => ({ name: pricelist.name, isSell: pricelist.isSell }))
    .sort((a, b) => a?.name.localeCompare(b.name))
}

export {
  key,
  obtainDiscountDataParts,
  obtainPriceListFromData,
  obtainBrandsFromData,
  obtainDiscountElementsFromData,
  obtainExcelDataFromDiscountData,
  obtainExcelDataFromsubRuleArticles,
  isRuleNameMaxLengthValid,
  isRuleNameMinLengthValid,
  isRuleEditToDisable,
  isRuleNameUnique,
  retrieveRule,
  retrieveCurrentSeasonAndRules,
  retrieveSubrule,
  retrieveSeasonRuleSubrulesList,
  retrieveAvailableSeasons,
  retrieveChannelMatchWithPricelist,
  retrieveStoresMatchWithPricelist,
  generateRuleName,
  retrieveVirtualRulesFromSeasonRuleList,
  createNewVirtualRule,
  generateVirtualRuleData,
  retrieveVirtualSubRulesFromSeasonRuleList,
  generateVirtualSeason,
  generateRuleCopy,
  createNewVirtualSubrule,
  retrieveVirtualRules,
  calculateMostRecentSeasonRuleStartEndDate,
  isStartDateInvalidForRuleEdit,
  retrieveRuleFromSubrule,
  retrievePricelistForSubrule,
  selectedRuleIsInSeason,
  deleteVirtualSubrules,
  obtainPriceDiscount,
  ruleHasSubrules,
  retrieveSubruleId,
  generateSubruleParams,
  isRuleLockedByOtherUsers,
  isRuleLockedByCurrentUser,
  retrieveSitesMatchWithPricelist as retrieveSiteMatchWithPriceList,
  retrieveActiveListings,
}
